import { defineComponent as _defineComponent } from 'vue'
import { BaseIcon, BaseText, Heading } from '@warrenbrasil/nebraska-web';

interface Props {
  label: string;
  icon: string;
  secondaryText?: string;
}

interface Emits {
  (event: 'on-click'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonBoxIcon',
  props: {
    label: null,
    icon: null,
    secondaryText: { default: '' }
  },
  emits: ["on-click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'on-click'): void;
}), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emits, BaseIcon, BaseText, Heading }
}

})